export default "__VITE_ASSET__DzbycmM1__"